var React = require('react');

function Reason2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"High quality materials"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icoWhy2","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":2},React.createElement("g",{"transform":"translate(6.000000, 8.000000)","stroke":"#FF9E34"},[React.createElement("polygon",{"id":"Stroke-1","points":"37.2466 0.5001 8.7536 0.5001 0.4996 13.6151 45.4996 13.6151","key":0}),React.createElement("polyline",{"id":"Stroke-3","points":"45.4996 13.6153 23.2266 40.0733 0.4996 13.6153","key":1}),React.createElement("polyline",{"id":"Stroke-5","points":"8.7535 0.5001 13.6155 13.6151 23.1125 0.5001 32.8305 13.6151 37.2465 0.5001","key":2}),React.createElement("polyline",{"id":"Stroke-7","points":"32.8306 13.6153 23.2266 40.0733 13.6156 13.6153","key":3})]))]);
}

Reason2.defaultProps = {"width":"57px","height":"57px","viewBox":"0 0 57 57","version":"1.1"};

module.exports = Reason2;

Reason2.default = Reason2;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/reason-2.svg
// module id = 1170
// module chunks = 0